import {styled, SxProps} from "@mui/material";
import theme, {FONTS} from "../../../constants/theme";
import {scale} from "../../../utils";
import Text from "../../text";
import React from "react";
import {useMediaQuery} from "@mui/system";

interface Props {
  title: string;
  sx?: SxProps;
}

const Wrapper = styled('div')({
  display: "flex",
  flexDirection: "column",
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.main,
  height: scale(60),
  width: 'calc(100% - 4px)',
  [theme.breakpoints.down('sm')]: {
    backgroundColor: theme.palette.white.main,
  },
});

const BaseTitle = ({title, sx}: Props) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Wrapper sx={sx}>
      <Text
        text={title}
        color={isMobile ? theme.palette.text.secondary : theme.palette.text.primary}
        fontFamily={FONTS.MONTSERRAT}
        fontWeight={'bold'}
        fontSize={scale(32)}
        letterSpacing={0}
        sx={{textTransform: 'uppercase', textAlign: 'center'}}
      />
    </Wrapper>
  );
}

export default BaseTitle;
